var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h5',{staticClass:"ma-2 pa-2"},[_vm._v("Por favor faça o Login.")])])}
var staticRenderFns = []

export { render, staticRenderFns }